/**
 * EduFlow — libellés des éditeurs de blocs (FR). Fusionné dans `frTranslations`.
 */

export const eduflowBlockEditorsFr: Record<string, string> = {
  'eduflow.blockEditor.audio.estimatedSeconds': '~{{sec}}s estimé',
  'eduflow.blockEditor.audio.fileLabel': 'Fichier audio',
  'eduflow.blockEditor.audio.formatsHint': 'MP3, WAV, OGG',
  'eduflow.blockEditor.audio.generateButton': 'Générer l’audio',
  'eduflow.blockEditor.audio.generateTts': 'Générer TTS',
  'eduflow.blockEditor.audio.import': 'Importer',
  'eduflow.blockEditor.audio.langDe': 'Deutsch',
  'eduflow.blockEditor.audio.langEn': 'English',
  'eduflow.blockEditor.audio.langEs': 'Español',
  'eduflow.blockEditor.audio.langFr': 'Français',
  'eduflow.blockEditor.audio.langIt': 'Italiano',
  'eduflow.blockEditor.audio.language': 'Langue',
  'eduflow.blockEditor.audio.mistralVoice': 'Voix (Mistral TTS)',
  'eduflow.blockEditor.audio.mistralVoicePlaceholder': 'ID voix Mistral (console Mistral / API)',
  'eduflow.blockEditor.audio.voicesLoading': 'Chargement des voix…',
  'eduflow.blockEditor.audio.voicesLoadError': 'Impossible de charger les voix Mistral.',
  'eduflow.blockEditor.audio.voicesEmptyHint':
    'Aucune voix renvoyée par l’API. Vérifiez la clé Mistral (Administration → Intégrations). La synthèse utilise tout de même une voix par défaut.',
  'eduflow.blockEditor.audio.voiceFallbackOption': '{{id}} (défaut)',
  'eduflow.blockEditor.audio.generating': 'Génération…',
  'eduflow.blockEditor.audio.generateNeedText': 'Saisissez d’abord le texte à synthétiser.',
  'eduflow.blockEditor.audio.generateBadResponse': 'Réponse TTS invalide.',
  'eduflow.blockEditor.audio.generateSuccess': 'Audio généré.',
  'eduflow.blockEditor.audio.generateError': 'Synthèse impossible (Mistral TTS / intégrations).',
  'eduflow.blockEditor.audio.preview': 'Prévisualisation',
  'eduflow.blockEditor.audio.source': 'Source audio',
  'eduflow.blockEditor.audio.speedLabel': 'Vitesse : {{speed}}x',
  'eduflow.blockEditor.audio.syncWithText': 'Synchroniser avec le texte (sous-titres)',
  'eduflow.blockEditor.audio.syncWithTextHelp':
    'Dans le lecteur : une zone sous la forme d’onde affiche le texte par segments, calés sur la position de lecture (répartition estimée sur la durée du fichier, pas de fichier VTT).',
  'eduflow.blockEditor.audio.ttsPlaceholder': 'Saisissez le texte qui sera lu par la voix de synthèse…',
  'eduflow.blockEditor.audio.ttsText': 'Texte à synthétiser',
  'eduflow.blockEditor.audio.urlLabel': 'Ou URL du fichier audio',
  'eduflow.blockEditor.audio.urlPlaceholder': 'https://example.com/audio.mp3',
  'eduflow.blockEditor.browser.allowExternalAria': 'Autoriser d\'autres sites web',
  'eduflow.blockEditor.browser.allowExternalHelp': '{{off}} : iframe protégée (sandbox) — limite popups et comportements sortants. {{on}} : meilleure compatibilité avec des pages riches (vidéos, widgets) ; navigation possible dans le cadre.',
  'eduflow.blockEditor.browser.allowExternalOff': 'Désactivé',
  'eduflow.blockEditor.browser.allowExternalOn': 'Activé',
  'eduflow.blockEditor.browser.allowExternalTitle': 'Autoriser d’autres sites web',
  'eduflow.blockEditor.browser.frameTitleFallback': 'Page web intégrée',
  'eduflow.blockEditor.browser.fullscreen': 'Plein écran',
  'eduflow.blockEditor.browser.fullscreenTitle': 'Aperçu — Page web intégrée',
  'eduflow.blockEditor.browser.openTab': 'Ouvrir dans un onglet',
  'eduflow.blockEditor.browser.preview': 'Aperçu',
  'eduflow.blockEditor.browser.urlHelp': 'Saisissez l’adresse complète (https). L’aperçu est encadré par un décor de fenêtre — ce n’est pas un navigateur : l’apprenant ne modifie pas l’URL depuis cette interface.',
  'eduflow.blockEditor.browser.urlLabel': 'URL de la page',
  'eduflow.blockEditor.browser.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.chart.addLabel': 'Label',
  'eduflow.blockEditor.chart.addSeries': 'Série',
  'eduflow.blockEditor.chart.animation': 'Animation',
  'eduflow.blockEditor.chart.chartTitle': 'Titre du graphique',
  'eduflow.blockEditor.chart.chartType': 'Type de graphique',
  'eduflow.blockEditor.chart.colorTitle': 'Couleur',
  'eduflow.blockEditor.chart.datasets': 'Séries de données ({{count}})',
  'eduflow.blockEditor.chart.defaultLabel': 'Label {{n}}',
  'eduflow.blockEditor.chart.defaultSeries': 'Série {{n}}',
  'eduflow.blockEditor.chart.interactive': 'Interactif (infobulles)',
  'eduflow.blockEditor.chart.labelsX': 'Labels (axe X)',
  'eduflow.blockEditor.chart.noSeries': 'Aucune série. Cliquez sur « Série » pour ajouter.',
  'eduflow.blockEditor.chart.readerPreviewHint': 'Aperçu disponible en mode lecteur',
  'eduflow.blockEditor.chart.seriesNamePlaceholder': 'Nom de la série',
  'eduflow.blockEditor.chart.settings': 'Paramètres',
  'eduflow.blockEditor.chart.showGrid': 'Afficher la grille',
  'eduflow.blockEditor.chart.showLegend': 'Afficher la légende',
  'eduflow.blockEditor.chart.titlePlaceholder': 'Titre optionnel',
  'eduflow.blockEditor.chart.typeArea': 'Aire',
  'eduflow.blockEditor.chart.typeBar': 'Barres',
  'eduflow.blockEditor.chart.typeDoughnut': 'Anneau',
  'eduflow.blockEditor.chart.typeLine': 'Ligne',
  'eduflow.blockEditor.chart.typePie': 'Camembert',
  'eduflow.blockEditor.chart.typeRadar': 'Radar',
  'eduflow.blockEditor.timer.sectionTitle': 'Minuteur',
  'eduflow.blockEditor.timer.enable': 'Activer le minuteur (lecteur)',
  'eduflow.blockEditor.timer.modeLabel': 'Mode',
  'eduflow.blockEditor.timer.modeCountup': 'Minuteur (0 → limite)',
  'eduflow.blockEditor.timer.countupHint':
    'Les 10 dernières secondes avant la limite passent en rouge.',
  'eduflow.blockEditor.timer.modeCountdown': 'Décompte (limite → 0)',
  'eduflow.blockEditor.timer.countdownHint': 'Les 5 dernières secondes passent en rouge.',
  'eduflow.blockEditor.timer.maxSecondsLabel': 'Temps maximum (secondes)',
  'eduflow.blockEditor.evaluation.aiQuestions': 'Générer des questions IA',
  'eduflow.blockEditor.evaluation.editFullscreen': 'Éditer le formulaire (plein écran)',
  'eduflow.blockEditor.evaluation.hint': 'Ouvrez l’éditeur plein écran pour composer le formulaire : glissez les types de champs depuis la colonne de gauche et réordonnez les questions par la poignée.',
  'eduflow.blockEditor.evaluation.metaLine': '{{qPart}} · {{pPart}} au total',
  'eduflow.blockEditor.evaluation.pointPlural': 'points',
  'eduflow.blockEditor.evaluation.pointSingular': 'point',
  'eduflow.blockEditor.evaluation.questionPlural': 'questions',
  'eduflow.blockEditor.evaluation.questionSingular': 'question',
  'eduflow.blockEditor.evaluation.title': 'Formulaire d’évaluation',
  'eduflow.blockEditor.evaluationForm.addFreeText': 'Ajouter texte libre',
  'eduflow.blockEditor.evaluationForm.addOption': 'Option',
  'eduflow.blockEditor.evaluationForm.close': 'Fermer',
  'eduflow.blockEditor.evaluationForm.delete': 'Supprimer',
  'eduflow.blockEditor.evaluationForm.dropEmptyHint': 'Déposez ici un type de question depuis le panneau de gauche, ou utilisez le bouton « Ajouter ».',
  'eduflow.blockEditor.evaluationForm.escapeHint': 'Échap pour fermer',
  'eduflow.blockEditor.evaluationForm.expectedValue': 'Valeur attendue',
  'eduflow.blockEditor.evaluationForm.footerStats': '{{n}} question(s) · {{pts}} pts au total',
  'eduflow.blockEditor.evaluationForm.headerSubtitle': 'Glissez un type de question depuis la gauche vers la zone centrale. Réordonnez par la poignée ⋮⋮.',
  'eduflow.blockEditor.evaluationForm.headerTitle': 'Éditeur de formulaire d’évaluation',
  'eduflow.blockEditor.evaluationForm.maxAttempts': 'Tentatives max',
  'eduflow.blockEditor.evaluationForm.moveQuestion': 'Déplacer la question',
  'eduflow.blockEditor.evaluationForm.optionPlaceholder': 'Option…',
  'eduflow.blockEditor.evaluationForm.optionsHint': 'Cliquez sur le pictogramme pour marquer la ou les bonnes réponses.',
  'eduflow.blockEditor.evaluationForm.overlayUntitled': '(sans titre)',
  'eduflow.blockEditor.evaluationForm.paletteSubtitle': 'Déposez dans le canevas pour ajouter une question.',
  'eduflow.blockEditor.evaluationForm.paletteTitle': 'Champs',
  'eduflow.blockEditor.evaluationForm.passThreshold': 'Seuil de réussite : {{pct}}%',
  'eduflow.blockEditor.evaluationForm.pointsShort': 'pts',
  'eduflow.blockEditor.evaluationForm.qTypeDropdown': 'Liste déroulante',
  'eduflow.blockEditor.evaluationForm.qTypeFile': 'Fichier',
  'eduflow.blockEditor.evaluationForm.qTypeMultiple': 'Choix multiple',
  'eduflow.blockEditor.evaluationForm.qTypeNumeric': 'Numérique',
  'eduflow.blockEditor.evaluationForm.qTypeSingle': 'Choix unique',
  'eduflow.blockEditor.evaluationForm.qTypeText': 'Texte libre',
  'eduflow.blockEditor.evaluationForm.questionTitlePlaceholder': 'Intitulé de la question…',
  'eduflow.blockEditor.evaluationForm.refAnswerLabel': 'Réponse de référence (optionnelle)',
  'eduflow.blockEditor.evaluationForm.refAnswerPlaceholder': 'Réponse attendue…',
  'eduflow.blockEditor.evaluationForm.refEmptyHint': 'Sans référence : toute réponse non vide est acceptée.',
  'eduflow.blockEditor.evaluationForm.required': 'Oblig.',
  'eduflow.blockEditor.evaluationForm.semanticGrading': 'Notation IA (similarité sémantique)',
  'eduflow.blockEditor.evaluationForm.semanticThreshold': 'Seuil sémantique : {{pct}}%',
  'eduflow.blockEditor.evaluationForm.showCorrect': 'Afficher les bonnes réponses',
  'eduflow.blockEditor.evaluationForm.showResults': 'Afficher les résultats',
  'eduflow.blockEditor.evaluationForm.timeLimit': 'Limite de temps',
  'eduflow.blockEditor.evaluationForm.tolerance': 'Tolérance ±',
  'eduflow.blockEditor.glossary.add': 'Ajouter',
  'eduflow.blockEditor.glossary.categories': 'Catégories',
  'eduflow.blockEditor.glossary.definitionPlaceholder': 'Définition',
  'eduflow.blockEditor.glossary.description': 'Description',
  'eduflow.blockEditor.glossary.descriptionPlaceholder': 'Aide de lecture du vocabulaire...',
  'eduflow.blockEditor.glossary.enableQuiz': 'Activer le quiz intégré',
  'eduflow.blockEditor.glossary.includeInQuiz': 'Inclure dans le quiz',
  'eduflow.blockEditor.glossary.newCategoryPlaceholder': 'Nouvelle catégorie',
  'eduflow.blockEditor.glossary.noCategory': 'Sans catégorie',
  'eduflow.blockEditor.glossary.panelHint': 'Définissez vos termes et activez le mode quiz pour la révision.',
  'eduflow.blockEditor.glossary.panelTitle': 'Glossaire + Quiz intégré',
  'eduflow.blockEditor.glossary.termPlaceholder': 'Terme',
  'eduflow.blockEditor.glossary.termSingular': 'Terme',
  'eduflow.blockEditor.glossary.termsCount': 'Termes ({{count}})',
  'eduflow.blockEditor.glossary.titleLabel': 'Titre du glossaire',
  'eduflow.blockEditor.glossary.titlePlaceholder': 'Glossaire',
  'eduflow.blockEditor.htmlSource.formatButton': 'Reformater',
  'eduflow.blockEditor.htmlSource.formatTitle': 'Réindenter et structurer le HTML (même logique qu’à l’entrée en mode code)',
  'eduflow.blockEditor.htmlSource.findVerb': 'rechercher',
  'eduflow.blockEditor.htmlSource.indentVerb': 'indente',
  'eduflow.blockEditor.htmlSource.modeLabel': 'Mode code HTML',
  'eduflow.blockEditor.mindmap.addChild': 'Sous-nœud',
  'eduflow.blockEditor.mindmap.addMainBranch': 'Ajouter une branche principale',
  'eduflow.blockEditor.mindmap.branchTitle': 'Branche · {{title}}',
  'eduflow.blockEditor.mindmap.centralTheme': 'Thème central',
  'eduflow.blockEditor.mindmap.close': 'Fermer',
  'eduflow.blockEditor.mindmap.configureFullscreen': 'Configurer en plein écran',
  'eduflow.blockEditor.mindmap.descriptionLabel': 'Description',
  'eduflow.blockEditor.mindmap.descriptionPlaceholder': 'Texte d’approfondissement',
  'eduflow.blockEditor.mindmap.dialogTitle': 'Carte heuristique',
  'eduflow.blockEditor.mindmap.optional': 'Optionnel',
  'eduflow.blockEditor.mindmap.playerHint': 'Au lecteur : carte horizontale (texte sur trait coloré, courbes, pastilles). Zoom dans l’en-tête du bloc. URL : icône ↗ (nouvel onglet).',
  'eduflow.blockEditor.mindmap.remove': 'Supprimer',
  'eduflow.blockEditor.mindmap.structure': 'Structure',
  'eduflow.blockEditor.mindmap.subtitleLabel': 'Sous-titre',
  'eduflow.blockEditor.mindmap.titleLabel': 'Titre',
  'eduflow.blockEditor.mindmap.titlePlaceholder': 'Titre du nœud',
  'eduflow.blockEditor.mindmap.untitled': 'Sans titre',
  'eduflow.blockEditor.mindmap.urlLabel': 'Lien URL',
  'eduflow.blockEditor.mindmap.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.pdf.allowDownload': 'Autoriser le téléchargement',
  'eduflow.blockEditor.pdf.badgePdf': 'PDF',
  'eduflow.blockEditor.pdf.completionLabel': 'Texte de validation',
  'eduflow.blockEditor.pdf.completionPlaceholder': 'Document consulté',
  'eduflow.blockEditor.pdf.documentFallback': 'Document PDF',
  'eduflow.blockEditor.pdf.emptyLibrary': 'Aucun document dans votre bibliothèque.',
  'eduflow.blockEditor.pdf.focusMode': 'Focus document',
  'eduflow.blockEditor.pdf.focusModeDesc': 'Chrome allégé, lecture centrée',
  'eduflow.blockEditor.pdf.importFailed': 'Import impossible',
  'eduflow.blockEditor.pdf.importFailedGeneric': 'L\'import a échoué.',
  'eduflow.blockEditor.pdf.importSubtitle': 'Le document sera ajouté à votre bibliothèque documents.',
  'eduflow.blockEditor.pdf.importTitle': 'Importer un PDF',
  'eduflow.blockEditor.pdf.librarySubtitle': 'Importez un PDF dans votre bibliothèque ou sélectionnez-en un existant.',
  'eduflow.blockEditor.pdf.libraryTitle': 'Bibliothèque documents',
  'eduflow.blockEditor.pdf.loadingDocs': 'Chargement des documents…',
  'eduflow.blockEditor.pdf.myDocuments': 'Mes documents',
  'eduflow.blockEditor.pdf.pagesAuto': 'Le lecteur détectera automatiquement le nombre de pages.',
  'eduflow.blockEditor.pdf.pagesDetected': '{{count}} pages détectées',
  'eduflow.blockEditor.pdf.pickFromLibrary': 'Sélectionnez un PDF déjà importé dans votre bibliothèque.',
  'eduflow.blockEditor.pdf.previewTitle': 'Aperçu du document',
  'eduflow.blockEditor.pdf.readerMode': 'Lecteur moderne',
  'eduflow.blockEditor.pdf.readerModeDesc': 'Page par page, zoom, plein écran',
  'eduflow.blockEditor.pdf.readingExperience': 'Expérience de lecture',
  'eduflow.blockEditor.pdf.showProgress': 'Afficher la progression de lecture',
  'eduflow.blockEditor.pdf.smartExtractSoon': 'Extraction intelligente bientôt',
  'eduflow.blockEditor.pdf.startPage': 'Page de départ',
  'eduflow.blockEditor.pdf.uploadedDesc': '{{name}} est maintenant disponible dans votre bibliothèque documents.',
  'eduflow.blockEditor.pdf.uploadedToast': 'PDF importé',
  'eduflow.blockEditor.pdf.uploading': 'Upload en cours',
  'eduflow.blockEditor.phraseReveal.addPhrase': 'Ajouter une phrase',
  'eduflow.blockEditor.phraseReveal.aiSummaryTitle': 'Générer un récapitulatif IA depuis les blocs en amont',
  'eduflow.blockEditor.phraseReveal.autoScroll': 'Défilement automatique',
  'eduflow.blockEditor.phraseReveal.displayDuration': 'Durée par phrase (s)',
  'eduflow.blockEditor.phraseReveal.editorHint': 'Ajoutez une ou plusieurs phrases avec l’éditeur enrichi. Le lecteur affiche une phrase à la fois ; clic ou Espace pour la suivante.',
  'eduflow.blockEditor.phraseReveal.emptyPhrase': 'Phrase vide',
  'eduflow.blockEditor.phraseReveal.importLegacy': 'Importer l’ancien champ « Texte à révéler » en phrases (recommandé).',
  'eduflow.blockEditor.phraseReveal.noPhrases': 'Aucune phrase pour l’instant.',
  'eduflow.blockEditor.phraseReveal.phraseContent': 'Contenu de la phrase',
  'eduflow.blockEditor.phraseReveal.phrasePlaceholder': 'Saisissez le texte de cette étape…',
  'eduflow.blockEditor.phraseReveal.showHistory': 'Afficher l’historique des phrases',
  'eduflow.blockEditor.phraseReveal.showHistoryHelp': 'Les phrases déjà vues s’affichent dans une carte entre la phrase en cours et la description du bloc.',
  'eduflow.blockEditor.presentation.addSlide': 'Diapositive',
  'eduflow.blockEditor.presentation.autoAdvance': 'Avance automatique',
  'eduflow.blockEditor.presentation.delayLabel': 'Délai : {{sec}}s',
  'eduflow.blockEditor.presentation.duplicateTitleSuffix': ' (copie)',
  'eduflow.blockEditor.presentation.globalSettings': 'Paramètres globaux',
  'eduflow.blockEditor.presentation.layoutImageText': 'Image + texte',
  'eduflow.blockEditor.presentation.layoutTitleContent': 'Titre + contenu',
  'eduflow.blockEditor.presentation.layoutTitleOnly': 'Titre seul',
  'eduflow.blockEditor.presentation.layoutTwoCol': 'Deux colonnes',
  'eduflow.blockEditor.presentation.layoutVideoOnly': 'Vidéo seul',
  'eduflow.blockEditor.presentation.layoutVideoText': 'Texte + vidéo',
  'eduflow.blockEditor.presentation.loop': 'Boucle',
  'eduflow.blockEditor.presentation.noSlides': 'Aucune diapositive. Cliquez pour en ajouter.',
  'eduflow.blockEditor.presentation.slideCount_one': '{{count}} diapositive',
  'eduflow.blockEditor.presentation.slideCount_other': '{{count}} diapositives',
  'eduflow.blockEditor.presentation.slideNumbers': 'Numéros de diapositives',
  'eduflow.blockEditor.presentation.slidesHeading': 'Diapositives',
  'eduflow.blockEditor.presentation.transition': 'Transition',
  'eduflow.blockEditor.presentation.transitionFade': 'Fondu',
  'eduflow.blockEditor.presentation.transitionNone': 'Aucune',
  'eduflow.blockEditor.presentation.transitionSlide': 'Glissement',
  'eduflow.blockEditor.presentation.transitionZoom': 'Zoom',
  'eduflow.blockEditor.quiz.addAnswer': 'Ajouter une réponse',
  'eduflow.blockEditor.quiz.addOrderingItem': 'Ajouter un élément',
  'eduflow.blockEditor.quiz.aiMcqTitle': 'Générer un QCM par IA à partir des blocs en amont',
  'eduflow.blockEditor.quiz.answerPlaceholder': 'Réponse {{n}}',
  'eduflow.blockEditor.quiz.answersCount': 'Réponses ({{count}}/10)',
  'eduflow.blockEditor.quiz.branching': 'Branchement',
  'eduflow.blockEditor.quiz.correctAnswer': 'Bonne réponse',
  'eduflow.blockEditor.quiz.correctAnswerPlaceholder': 'Sélectionner…',
  'eduflow.blockEditor.quiz.explanation': 'Explication',
  'eduflow.blockEditor.quiz.explanationPlaceholder': 'Explication complémentaire...',
  'eduflow.blockEditor.quiz.false': 'Faux',
  'eduflow.blockEditor.quiz.feedback': 'Feedback',
  'eduflow.blockEditor.quiz.ifCorrect': 'Si correct →',
  'eduflow.blockEditor.quiz.ifIncorrect': 'Si incorrect →',
  'eduflow.blockEditor.quiz.markAsCorrect': 'Marquer comme correcte',
  'eduflow.blockEditor.quiz.markCorrect': 'Réponse correcte',
  'eduflow.blockEditor.quiz.msgCorrect': 'Message si correct',
  'eduflow.blockEditor.quiz.msgCorrectPlaceholder': 'Bravo ! C\'est la bonne réponse.',
  'eduflow.blockEditor.quiz.msgIncorrect': 'Message si incorrect',
  'eduflow.blockEditor.quiz.msgIncorrectPlaceholder': 'Ce n\'est pas la bonne réponse.',
  'eduflow.blockEditor.quiz.nextBlockAuto': 'Bloc suivant (auto)',
  'eduflow.blockEditor.quiz.orderingHint': 'Éléments à ordonner (l’ordre actuel = ordre correct)',
  'eduflow.blockEditor.quiz.orderingItemPlaceholder': 'Élément {{n}}',
  'eduflow.blockEditor.quiz.partialScoring': 'Score partiel (QCM)',
  'eduflow.blockEditor.quiz.question': 'Question',
  'eduflow.blockEditor.quiz.questionPlaceholder': 'Saisissez votre question...',
  'eduflow.blockEditor.quiz.quizType': 'Type de quiz',
  'eduflow.blockEditor.quiz.score': 'Score',
  'eduflow.blockEditor.quiz.showCorrect': 'Afficher la réponse correcte',
  'eduflow.blockEditor.quiz.shuffle': 'Mélanger',
  'eduflow.blockEditor.quiz.true': 'Vrai',
  'eduflow.blockEditor.quiz.typeMcq': 'QCM',
  'eduflow.blockEditor.quiz.typeFillBlank': 'Texte à trous',
  'eduflow.blockEditor.quiz.typeOrdering': 'Classement',
  'eduflow.blockEditor.quiz.typeTrueFalse': 'Vrai / Faux',
  'eduflow.blockEditor.quiz.branchingMode': 'Mode de branchement',
  'eduflow.blockEditor.quiz.branchingNone': 'Aucun (linéaire)',
  'eduflow.blockEditor.quiz.branchingCorrectIncorrect': 'Correct / Incorrect',
  'eduflow.blockEditor.quiz.branchingPerAnswer': 'Par réponse individuelle',
  'eduflow.blockEditor.quiz.answerOptions': "Options de réponse",
  'eduflow.blockEditor.quiz.optionLetter': "Option {{letter}}",
  'eduflow.blockEditor.quiz.feedbackAfter': "Feedback après réponse",
  'eduflow.blockEditor.quiz.feedbackAfterPlaceholder': "Message affiché après validation…",
  'eduflow.quizAi.title': "QCM par IA",
  'eduflow.quizAi.subtitle': "Blocs en amont du quiz — sélection et génération.",
  'eduflow.quizAi.fallback': "Aucun enchaînement trouvé vers ce quiz : tous les autres blocs du parcours sont listés. Reliez les blocs avec des connexions pour n’afficher que l’amont réel.",
  'eduflow.quizAi.noBlocks': "Aucun autre bloc dans ce parcours. Ajoutez du contenu avant le quiz, puis reconnectez ce bloc.",
  'eduflow.quizAi.instructions': "Cochez un ou plusieurs blocs dont le texte servira de base à la question (4 réponses, 1 correcte).",
  'eduflow.quizAi.tooShort': "Texte trop court",
  'eduflow.quizAi.generate': "Générer la question",
  'eduflow.quizAi.preview': "Aperçu",
  'eduflow.quizAi.apply': "Appliquer au quiz",
  'eduflow.quizAi.needText': "Sélectionnez au moins un bloc avec assez de texte (titres + contenu : minimum {{min}} caractères par bloc).",
  'eduflow.quizAi.error': "Erreur lors de la génération",
  'eduflow.blockEditor.loop.maxIterationsLabel': "Nombre maximum d'itérations (0 = infini)",
  'eduflow.blockEditor.loop.infiniteHint':
    "La boucle continuera indéfiniment jusqu'à ce que la condition soit remplie.",
  'eduflow.blockEditor.loop.limitedHint': "La boucle s'arrêtera après {{count}} tentative(s) maximum.",
  'eduflow.blockEditor.loop.howItWorksTitle': 'Comment ça fonctionne :',
  'eduflow.blockEditor.loop.howItWorksText':
    "La boucle redirigera l'utilisateur vers le bloc connecté sur la sortie « Boucle » tant que la condition n'est pas remplie (nombre max d'itérations : 0 = infini). Utilisez la sortie « Fin » pour la suite du parcours.",
  'eduflow.blockEditor.selfAssessment.addBadge': 'Ajouter',
  'eduflow.blockEditor.selfAssessment.addCriterion': 'Ajouter',
  'eduflow.blockEditor.selfAssessment.badgeInputPlaceholder': 'Ex. Souvent, Jamais, Parfois…',
  'eduflow.blockEditor.selfAssessment.badgeOptionsHint': 'Mots ou courtes expressions : l’apprenant les choisit comme pastilles. Sans proposition → champ texte libre.',
  'eduflow.blockEditor.selfAssessment.badgeOptionsLabel': 'Propositions (badges)',
  'eduflow.blockEditor.selfAssessment.criteriaSection': 'Critères',
  'eduflow.blockEditor.selfAssessment.criterionDescription': 'Description (optionnelle)',
  'eduflow.blockEditor.selfAssessment.criterionDescriptionPh': 'Précisez ce que l’apprenant doit observer ou comment se positionner…',
  'eduflow.blockEditor.selfAssessment.criterionTitle': 'Intitulé',
  'eduflow.blockEditor.selfAssessment.criterionTitlePh': 'Ex. Communication, Autonomie…',
  'eduflow.blockEditor.selfAssessment.emptyCriteria': 'Aucun critère. Ajoutez au moins une ligne pour que l’apprenant puisse s’auto-évaluer.',
  'eduflow.blockEditor.selfAssessment.moveDown': 'Descendre',
  'eduflow.blockEditor.selfAssessment.moveUp': 'Monter',
  'eduflow.blockEditor.selfAssessment.panelHint': 'Définissez chaque dimension à noter : intitulé court et, si besoin, une description pour guider l’apprenant.',
  'eduflow.blockEditor.selfAssessment.panelTitle': 'Auto-évaluation',
  'eduflow.blockEditor.selfAssessment.removeBadge': 'Retirer',
  'eduflow.blockEditor.selfAssessment.removeCriterion': 'Supprimer ce critère',
  'eduflow.blockEditor.selfAssessment.responseTypeLabel': 'Type de réponse',
  'eduflow.blockEditor.selfAssessment.scaleHint': 'De 1 à N (ex. 5 = Likert)',
  'eduflow.blockEditor.selfAssessment.scaleLabel': 'Échelle de notation',
  'eduflow.blockEditor.selfAssessment.starCountHint': 'Souvent 5',
  'eduflow.blockEditor.selfAssessment.starCountLabel': 'Nombre d’étoiles',
  'eduflow.blockEditor.selfAssessment.textModeHint': 'Par critère : ajoutez des propositions en badges (sélection) ou laissez vide pour une réponse rédigée. Le commentaire global reste sous les critères au lecteur.',
  'eduflow.blockEditor.selfAssessment.typeNumeric': 'Chiffres',
  'eduflow.blockEditor.selfAssessment.typeNumericHint': 'Boutons 1 à N',
  'eduflow.blockEditor.selfAssessment.typeStars': 'Étoiles',
  'eduflow.blockEditor.selfAssessment.typeStarsHint': 'Notation visuelle',
  'eduflow.blockEditor.selfAssessment.typeText': 'Texte libre',
  'eduflow.blockEditor.selfAssessment.typeTextHint': 'Réponse rédigée par critère',
  'eduflow.blockEditor.shared.alignCenter': 'Centrer',
  'eduflow.blockEditor.shared.alignLeft': 'Aligner à gauche',
  'eduflow.blockEditor.shared.alignRight': 'Aligner à droite',
  'eduflow.blockEditor.shared.annotationCount_one': '{{count}} annotation',
  'eduflow.blockEditor.shared.annotationCount_other': '{{count}} annotations',
  'eduflow.blockEditor.shared.blocksCount': '{{count}} blocs',
  'eduflow.blockEditor.shared.bold': 'Gras',
  'eduflow.blockEditor.shared.border': 'Bordure',
  'eduflow.blockEditor.shared.bulletList': 'Liste à puces',
  'eduflow.blockEditor.shared.cancel': 'Annuler',
  'eduflow.blockEditor.shared.choose': 'Choisir',
  'eduflow.blockEditor.shared.close': 'Fermer',
  'eduflow.blockEditor.shared.configure': 'Configurer',
  'eduflow.blockEditor.shared.delete': 'Supprimer',
  'eduflow.blockEditor.shared.duplicate': 'Dupliquer',
  'eduflow.blockEditor.shared.imageLabel': 'Image',
  'eduflow.blockEditor.shared.italic': 'Italique',
  'eduflow.blockEditor.shared.layoutPrefix': 'Layout : ',
  'eduflow.blockEditor.shared.linked': 'Lié',
  'eduflow.blockEditor.shared.maxAttempts': 'Tentatives max',
  'eduflow.blockEditor.shared.mediaImage': ' Image',
  'eduflow.blockEditor.shared.mediaNone': ' Pas de média',
  'eduflow.blockEditor.shared.mediaVideo': ' Vidéo',
  'eduflow.blockEditor.shared.minutes': 'Minutes',
  'eduflow.blockEditor.shared.noImage': 'Aucune image',
  'eduflow.blockEditor.shared.numberedList': 'Liste numérotée',
  'eduflow.blockEditor.shared.option': 'Option',
  'eduflow.blockEditor.shared.pages': '{{count}} pages',
  'eduflow.blockEditor.shared.points': 'Points',
  'eduflow.blockEditor.shared.retry': 'Réessayer',
  'eduflow.blockEditor.shared.rounded': 'Coins arrondis',
  'eduflow.blockEditor.shared.save': 'Enregistrer',
  'eduflow.blockEditor.shared.selected': 'Sélectionné',
  'eduflow.blockEditor.shared.shadow': 'Ombre',
  'eduflow.blockEditor.shared.slideCounter': 'Slide {{index}}/{{total}}',
  'eduflow.blockEditor.shared.speedTicks': '{{v}}x',
  'eduflow.blockEditor.shared.strike': 'Barré',
  'eduflow.blockEditor.shared.underline': 'Souligné',
  'eduflow.blockEditor.shared.untitledSlide': 'Sans titre',
  'eduflow.blockEditor.shared.updatedOn': 'Mis à jour {{date}}',
  'eduflow.blockEditor.subflow.emptyPublished': 'Aucune formation publiée disponible',
  'eduflow.blockEditor.subflow.emptySearch': 'Aucune formation trouvée',
  'eduflow.blockEditor.subflow.linkedTraining': 'Sous-formation liée',
  'eduflow.blockEditor.subflow.loadError': 'Impossible de charger les formations',
  'eduflow.blockEditor.subflow.loading': 'Chargement…',
  'eduflow.blockEditor.subflow.openInTab': 'Ouvrir la sous-formation dans un nouvel onglet',
  'eduflow.blockEditor.subflow.remove': 'Retirer',
  'eduflow.blockEditor.subflow.searchPlaceholder': 'Rechercher une formation publiée…',
  'eduflow.blockEditor.summary.addItem': 'Ajouter un point',
  'eduflow.blockEditor.summary.aiRecapTitle': 'Générer un récapitulatif IA depuis les blocs en amont',
  'eduflow.blockEditor.summary.editorHint': 'Liste les notions ou étapes vues dans la formation. Chaque ligne apparaît comme une puce dans le lecteur.',
  'eduflow.blockEditor.summary.emptyList': 'Aucun point pour l’instant. Ajoutez-en un.',
  'eduflow.blockEditor.summary.itemPlaceholder': 'Ex. : Les risques incendie en entreprise',
  'eduflow.blockEditor.text.audioTts': 'Audio (TTS)',
  'eduflow.blockEditor.text.charWordCount': '{{chars}} caractères · {{words}} mots',
  'eduflow.blockEditor.text.content': 'Contenu',
  'eduflow.blockEditor.text.contentPlaceholder': 'Saisissez le contenu du bloc texte…',
  'eduflow.blockEditor.text.formatting': 'Mise en forme',
  'eduflow.blockEditor.text.headingH1': 'Titre 1',
  'eduflow.blockEditor.text.headingH2': 'Titre 2',
  'eduflow.blockEditor.text.headingH3': 'Titre 3',
  'eduflow.blockEditor.text.headingH4': 'Titre 4',
  'eduflow.blockEditor.text.headingH5': 'Titre 5',
  'eduflow.blockEditor.text.headingH6': 'Titre 6',
  'eduflow.blockEditor.text.headingLevel': 'Niveau de titre',
  'eduflow.blockEditor.text.headingParagraph': 'Paragraphe',
  'eduflow.blockEditor.text.previewSoon': 'Prévisualiser (bientôt)',
  'eduflow.blockEditor.text.readTime': '~{{min}} min de lecture',
  'eduflow.blockEditor.text.speedLabel': 'Vitesse : {{speed}}x',
  'eduflow.blockEditor.text.voice': 'Voix',
  'eduflow.blockEditor.text.voiceAdam': 'Adam (FR masculin)',
  'eduflow.blockEditor.text.voiceBella': 'Bella (FR féminin)',
  'eduflow.blockEditor.text.voiceHeart': 'Heart (FR féminin)',
  'eduflow.blockEditor.text.voiceMichael': 'Michael (EN masculin)',
  'eduflow.blockEditor.text.voiceNova': 'Nova (EN féminin)',
  'eduflow.blockEditor.text.voiceSky': 'Sky (EN féminin)',
  'eduflow.blockEditor.timeline.addEvent': 'Événement',
  'eduflow.blockEditor.timeline.alternatingSides': 'Côtés alternés',
  'eduflow.blockEditor.timeline.animatedReveal': 'Révélation animée',
  'eduflow.blockEditor.timeline.colorHint': 'Couleur du point (optionnel)',
  'eduflow.blockEditor.timeline.colorLabel': 'Couleur',
  'eduflow.blockEditor.timeline.datePlaceholder': 'Date ou période (ex. 1789, janv. 2024)',
  'eduflow.blockEditor.timeline.descPlaceholder': 'Description (affichée au développement)',
  'eduflow.blockEditor.timeline.emptyEvents': 'Aucun événement. Ajoutez-en un pour construire la frise.',
  'eduflow.blockEditor.timeline.events': 'Événements',
  'eduflow.blockEditor.timeline.horizontal': 'Horizontale',
  'eduflow.blockEditor.timeline.iconAward': 'Médaille',
  'eduflow.blockEditor.timeline.iconCheck': 'Validation',
  'eduflow.blockEditor.timeline.iconClock': 'Horloge',
  'eduflow.blockEditor.timeline.iconFlag': 'Drapeau',
  'eduflow.blockEditor.timeline.iconStar': 'Étoile',
  'eduflow.blockEditor.timeline.moveDown': 'Descendre',
  'eduflow.blockEditor.timeline.moveUp': 'Monter',
  'eduflow.blockEditor.timeline.orientation': 'Orientation',
  'eduflow.blockEditor.timeline.settings': 'Paramètres',
  'eduflow.blockEditor.timeline.showConnectors': 'Lignes de connexion',
  'eduflow.blockEditor.timeline.titlePlaceholder': 'Titre de l\'événement',
  'eduflow.blockEditor.timeline.untitled': 'Sans titre',
  'eduflow.blockEditor.timeline.vertical': 'Verticale',
  'eduflow.blockEditor.videoSubtitles.cancel': 'Annuler',
  'eduflow.blockEditor.videoSubtitles.invalidResponse': 'Réponse invalide du serveur.',
  'eduflow.blockEditor.videoSubtitles.invalidUrl': 'URL de piste invalide.',
  'eduflow.blockEditor.videoSubtitles.loadError': 'Chargement impossible.',
  'eduflow.blockEditor.videoSubtitles.loadFailed': 'Impossible de charger la piste ({{status}}).',
  'eduflow.blockEditor.videoSubtitles.loading': 'Chargement des segments…',
  'eduflow.blockEditor.videoSubtitles.modalSubtitle': 'Un bloc par apparition à l’écran. Les horaires sont conservés ; seul le texte est modifiable.',
  'eduflow.blockEditor.videoSubtitles.modalTitle': 'Éditer les sous-titres',
  'eduflow.blockEditor.videoSubtitles.noSegments': 'Aucun segment lisible dans le fichier sous-titres.',
  'eduflow.blockEditor.videoSubtitles.saveFailed': 'Enregistrement impossible.',
  'eduflow.blockEditor.videoSubtitles.saveTrack': 'Enregistrer la piste',
  'eduflow.blockEditor.videoSubtitles.savedToast': 'Sous-titres enregistrés',
  'eduflow.blockEditor.videoSubtitles.segmentN': 'Segment {{n}}',
  'eduflow.blockEditor.videoSubtitles.segmentRequiredToast': 'Au moins un segment avec du texte est requis.',
  'eduflow.blockEditor.videoSubtitles.trackLang': 'Langue piste : {{label}}',
  'eduflow.designer.blockLabel.audio': 'Audio',

  /** Bloc Vidéo — éditeur */
  'eduflow.blockEditor.video.autoCaptionBullet': 'Extraction audio (ffmpeg) puis transcription Mistral. URL directe .mp4 recommandée ; pas de page YouTube.',
  'eduflow.blockEditor.video.autoCaptionErrorFallback':
    'Vérifiez la clé Mistral, ffmpeg sur le serveur et que la vidéo contient de l’audio.',
  'eduflow.blockEditor.video.autoCaptionSection': 'Sous-titres automatiques',
  'eduflow.blockEditor.video.autoCaptionsButton': 'Générer sous-titres (audio + IA)',
  'eduflow.blockEditor.video.availableSubtitlesChip': 'Sous-titres disponibles',
  'eduflow.blockEditor.video.completionThreshold': 'Seuil de complétion (%)',
  'eduflow.blockEditor.video.editCueButton': 'Modifier les sous-titres (par segment)',
  'eduflow.blockEditor.video.endSeconds': 'Fin (sec)',
  'eduflow.blockEditor.video.escHint': 'Esc pour fermer',
  'eduflow.blockEditor.video.libraryEmpty': 'Aucune vidéo disponible dans votre bibliothèque.',
  'eduflow.blockEditor.video.libraryTitle': 'Bibliothèque vidéos',
  'eduflow.blockEditor.video.libraryHint': 'Sélectionnez une vidéo déjà importée dans votre dashboard concepteur.',
  'eduflow.blockEditor.video.libraryLoading': 'Chargement des vidéos…',
  'eduflow.blockEditor.video.optionalEnd': 'Optionnel',
  'eduflow.blockEditor.video.accent.primary': 'Primaire',
  'eduflow.blockEditor.video.aspectFormat': 'Format',
  'eduflow.blockEditor.video.aspect.ratio169': '16:9',
  'eduflow.blockEditor.video.aspect.ratio219': '21:9',
  'eduflow.blockEditor.video.aspect.ratio43': '4:3',
  'eduflow.blockEditor.video.aspect.ratio11': '1:1',
  'eduflow.blockEditor.video.pickFromLibrary': 'Choisir',
  'eduflow.blockEditor.video.playerBadge': 'Player vidéo',
  'eduflow.blockEditor.video.previewTitleFallback': 'Lecteur vidéo',
  'eduflow.blockEditor.video.reduced': 'Réduire',
  'eduflow.blockEditor.video.regenerateCaptions': 'Regénérer',
  'eduflow.blockEditor.video.previewHint': 'Upload, YouTube ou URL directe avec design personnalisable.',
  'eduflow.blockEditor.video.previewIframeTitle': 'Prévisualisation vidéo',
  'eduflow.blockEditor.video.subtitleBadge': 'Sous-titres',
  'eduflow.blockEditor.video.selected': 'Sélectionnée',
  'eduflow.blockEditor.video.designTab': 'Design',
  'eduflow.blockEditor.video.radius.soft': 'Légers',
  'eduflow.blockEditor.video.radius.rounded': 'Arrondis',
  'eduflow.blockEditor.video.radius.square': 'Carrés',
  'eduflow.blockEditor.video.shadow.soft': 'Douce',
  'eduflow.blockEditor.video.shadow.glow': 'Lueur',
  'eduflow.blockEditor.video.shadow.dramatic': 'Dramatique',
  'eduflow.blockEditor.video.shadowLabel': 'Ombre',
  'eduflow.blockEditor.video.radiusCornerLabel': 'Coins',
  'eduflow.blockEditor.video.themeEditorial.desc': 'Clair, propre, institutionnel',
  'eduflow.blockEditor.video.themeEditorial.label': 'Editorial',
  'eduflow.blockEditor.video.themeCinema.desc': 'Sombre, premium, immersif',
  'eduflow.blockEditor.video.themeCinema.label': 'Cinéma',
  'eduflow.blockEditor.video.themeGlass.desc': 'Translucide, moderne, lumineux',
  'eduflow.blockEditor.video.themeGlass.label': 'Glass',
  'eduflow.blockEditor.video.themeApp.desc': 'Par défaut, aligné avec le thème actuel',
  'eduflow.blockEditor.video.themeApp.label': 'Application',
  'eduflow.blockEditor.video.themeAccent': 'Couleur d’accent',
  'eduflow.blockEditor.video.themePlayer': 'Thème du player',
  'eduflow.blockEditor.video.toast.autoCaptionsError': 'Sous-titres automatiques indisponibles',
  'eduflow.blockEditor.video.toast.autoCaptionsOk': 'Sous-titres générés',
  'eduflow.blockEditor.video.toast.autoCaptionsOkDesc':
    'Ils s’affichent en temps réel pendant la lecture dans le player.',
  'eduflow.blockEditor.video.toast.uploadErrorDesc': 'L’import a échoué.',
  'eduflow.blockEditor.video.toast.uploadErrorTitle': 'Import impossible',
  'eduflow.blockEditor.video.toast.uploadedDesc': '{{name}} est prête dans votre bloc vidéo.',
  'eduflow.blockEditor.video.toast.uploadedTitle': 'Vidéo importée',
  'eduflow.blockEditor.video.fullscreenExpandTitle': 'Ouvrir en plein écran',
  'eduflow.blockEditor.video.fullscreenHeading': 'Bloc vidéo',
  'eduflow.blockEditor.video.importDragTitle': 'Importer une vidéo',
  'eduflow.blockEditor.video.importFormats': 'MP4, WebM, OGG, MOV · max {{maxMb}} MB côté UI',
  'eduflow.blockEditor.video.noneSelected': 'Aucune vidéo sélectionnée',
  'eduflow.blockEditor.video.playbackTab': 'Lecture',
  'eduflow.blockEditor.video.playbackSettingsTitle': 'Paramètres de lecture',
  'eduflow.blockEditor.video.loop': 'Boucle',
  'eduflow.blockEditor.video.autoplay': 'Lecture automatique',
  'eduflow.blockEditor.video.mutedStart': 'Muet au démarrage',
  'eduflow.blockEditor.video.showControls': 'Afficher les contrôles',
  'eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo':
    'Sur {{platform}}, activez les sous-titres dans le lecteur intégré (CC). Le player charge les pistes fournies par la plateforme.',
  'eduflow.blockEditor.video.trackReadyHint':
    'Piste WebVTT prête : dans le lecteur, affichage dans la langue choisie par l’apprenant (les 11 langues du player ; traduction à la volée si besoin).',
  'eduflow.blockEditor.video.langTranscriptionTrack': 'Langue (transcription / piste source)',
  'eduflow.blockEditor.video.placeholderUrlGeneric': 'https://example.com/video.mp4',
  'eduflow.blockEditor.video.placeholderVimeo': 'https://vimeo.com/…',
  'eduflow.blockEditor.video.placeholderYoutube': 'https://www.youtube.com/watch?v=…',
  'eduflow.blockEditor.video.invalidUrlSource': 'URL invalide pour cette source',
  'eduflow.blockEditor.video.urlHelpDirect':
    'Compatible avec les URLs directes vers un fichier vidéo.',
  'eduflow.blockEditor.video.labelUrlGeneric': 'URL de la vidéo',
  'eduflow.blockEditor.video.labelUrlVimeo': 'URL Vimeo',
  'eduflow.blockEditor.video.labelUrlYoutube': 'URL YouTube',
  'eduflow.blockEditor.video.readyInBlock': 'Vidéo prête dans le bloc',
  'eduflow.blockEditor.video.uploadInProgress': 'Upload en cours',
  'eduflow.blockEditor.video.sectionSubtitlesDesign': 'Sous-titres',
  'eduflow.blockEditor.video.sourceLabel': 'Source vidéo',
  'eduflow.blockEditor.video.sourceTab': 'Source',
  'eduflow.blockEditor.video.sourceUrl': 'URL',
  'eduflow.blockEditor.video.sourceUpload': 'Fichier',
  'eduflow.blockEditor.video.startSeconds': 'Début (sec)',
  'eduflow.blockEditor.video.showPlayerHeader': 'Afficher l’en-tête du player',
  'eduflow.blockEditor.video.accent.amber': 'Ambre',
  'eduflow.blockEditor.video.accent.emerald': 'Émeraude',

  /** Rich text (description / TipTap) */
  'eduflow.blockEditor.richText.collapsedHintHtml': 'Réduire l’éditeur (mode HTML actif)',
  'eduflow.blockEditor.richText.collapsedHintReopen': 'Cliquer pour rouvrir l’éditeur',
  'eduflow.blockEditor.richText.defaultPlaceholder': 'Écrivez votre contenu ici…',
  'eduflow.blockEditor.richText.fullscreenTitleFallback': 'Éditeur',
  'eduflow.blockEditor.richText.calloutBody': 'Votre texte ici…',
  'eduflow.blockEditor.richText.calloutTitle': 'Titre de l’encart',
  'eduflow.blockEditor.richText.fullscreen': 'Plein écran',
  'eduflow.blockEditor.richText.highlight': 'Surligner',
  'eduflow.blockEditor.richText.imageTab': 'Image',
  'eduflow.blockEditor.richText.importTab': 'Importer',
  'eduflow.blockEditor.richText.infoPanelBody': 'Ajoutez une information clé pour l’apprenant.',
  'eduflow.blockEditor.richText.infoPanelTitle': 'Bon à savoir',
  'eduflow.blockEditor.richText.inlineCode': 'Code inline',
  'eduflow.blockEditor.richText.insertBadge': 'Badge',
  'eduflow.blockEditor.richText.insertCallout': 'Encart',
  'eduflow.blockEditor.richText.insertCalloutCompact': 'Insérer un encart',
  'eduflow.blockEditor.richText.insertImage': 'Insérer une image',
  'eduflow.blockEditor.richText.insertImageAction': 'Insérer l’image',
  'eduflow.blockEditor.richText.insertInfoPanel': 'Panneau info',
  'eduflow.blockEditor.richText.insertVideo': 'Insérer une vidéo',
  'eduflow.blockEditor.richText.insertVideoAction': 'Insérer la vidéo',
  'eduflow.blockEditor.richText.libraryTab': 'Mes images',
  'eduflow.blockEditor.richText.link': 'Lien',
  'eduflow.blockEditor.richText.linkOk': 'OK',
  'eduflow.blockEditor.richText.linkPlaceholderHttps': 'https://…',
  'eduflow.blockEditor.richText.linkPrompt': 'URL du lien :',
  'eduflow.blockEditor.richText.mediaFormatsHint': 'PNG, JPG, GIF, WebP · max 10 Mo',
  'eduflow.blockEditor.richText.minimizeToolbar': 'Réduire',
  'eduflow.blockEditor.richText.modalLibraryEmpty': 'Aucune image dans votre bibliothèque',
  'eduflow.blockEditor.richText.modalUploading': 'Envoi en cours…',
  'eduflow.blockEditor.richText.openImportTab': 'Importer une image',
  'eduflow.blockEditor.richText.placeholderImageUrl': 'https://exemple.com/image.jpg',
  'eduflow.blockEditor.richText.placeholderYoutube': 'https://youtube.com/watch?v=…',
  'eduflow.blockEditor.richText.quote': 'Citation',
  'eduflow.blockEditor.richText.redo': 'Refaire',
  'eduflow.blockEditor.richText.separatorRule': 'Séparateur',
  'eduflow.blockEditor.richText.showHtmlSource': 'Afficher / modifier le HTML',
  'eduflow.blockEditor.richText.returnToVisual': 'Revenir à l’éditeur visuel',
  'eduflow.blockEditor.richText.tplBadgeLabel': 'Badge',
  'eduflow.blockEditor.richText.uploadDropPrompt': 'Glisser-déposer ou',
  'eduflow.blockEditor.richText.uploadDropClick': 'cliquer pour sélectionner',
  'eduflow.blockEditor.richText.heading1': 'Titre 1',
  'eduflow.blockEditor.richText.heading2': 'Titre 2',
  'eduflow.blockEditor.richText.heading3': 'Titre 3',
  'eduflow.blockEditor.richText.justify': 'Justifier',
  'eduflow.blockEditor.richText.undo': 'Annuler',
  'eduflow.blockEditor.richText.videoYoutubePaste': 'Coller l’URL YouTube ci-dessous',
  'eduflow.blockEditor.richText.videoYoutubeToolbar': 'Vidéo YouTube',
  'eduflow.blockEditor.richText.urlTab': 'URL',
};
